<template>
    <div class="billOperationRecord public_Spacing rebate-setting-page">
        <div class="pulbic_oparetionBlock rebate-setting-filter-card">
            <div class="rebate-setting-section-head">
                <div>
                    <div class="rebate-setting-section-title">筛选条件</div>
                    <div class="rebate-setting-section-subtitle">按客户、企业和物料查询返点配置</div>
                </div>
            </div>
            <div class="rebate-setting-filter-row">
                <div class="public_criteriaRange rebate-setting-criteria">
                <div class="public_oparetionBlock_Menu">
                    <label class="public_lbSty">客户：</label>
                    <el-select class="public_optionSty dropDown_Define" v-model="customerMo" placeholder="请选择"
                        filterable remote :remote-method="filterCustomer">
                        <el-option v-for="item in filteredCustomerOptions" :key="item.ORMTB410ID" :label="item.ORMTB410CA00"
                            :value="item.ORMTB410ID">
                        </el-option>
                    </el-select>
                </div>
                <div class="public_oparetionBlock_Menu">
                    <label class="public_lbSty">企业：</label>
                    <el-select class="public_optionSty dropDown_Define" @change="erpChange" v-model="enterpriseTwo"
                        placeholder="请选择" filterable remote :remote-method="filterEnterprise">
                        <el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
                            :label="item.SETTB99CA00" :value="item.SETTB99ID">
                        </el-option>
                    </el-select>
                </div>
                <div class="public_oparetionBlock_Menu">
                    <label class="public_lbSty">物料：</label>
                    <el-select class="public_optionSty dropDown_Define" v-model="materielMo" placeholder="请选择"
                        filterable>
                        <el-option v-for="item in materielOptions" :key="item.SETTB109ID" :label="item.SETTB109CA00"
                            :value="item.SETTB109ID">
                        </el-option>
                    </el-select>
                </div>
                </div>
                <div class="public_operatArea rebate-setting-actions-row">
                    <div class="public_operatBtn rebate-setting-actions">
                        <button @click="addClick"
                            class="public_saleWater_chaxun pulic_cursor public_saleWater_xinzeng">新增</button>
                        <button @click="queryClick" class="public_saleWater_chaxun pulic_cursor">查询</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="billOperationRecord-table pulbic_table_container rebate-setting-table-card">
            <div class="rebate-setting-table-head">
                <div>
                    <div class="rebate-setting-section-title">返点设置列表</div>
                    <div class="rebate-setting-section-subtitle">当前共 {{ pagingPageMo }} 条记录</div>
                </div>
            </div>
            <el-table tooltip-effect="dark" :data="tableData" style="width: 100%;"
                :default-sort="{ prop: 'waterNum', order: 'descending' }" :header-cell-style="{
                    color: 'rgba(51,51,51,1)',
                    background: 'rgba(184,227,255,1)',
                    'font-weight': 'bold',
                }" class="public_tableColumn">
                <el-table-column align="center" prop="SETTB420CA04" label="客户名称" min-width="180" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="SETTB420CA00" label="企业名称" min-width="180" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="SETTB420CA02" label="物料名称" min-width="180" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="SETTB420CA07" label="返点比率" min-width="120"></el-table-column>
                <el-table-column align="center" prop="SETTB420CA09" label="开始时间" min-width="170" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="SETTB420CA10" label="结束时间" min-width="170" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="操作" width="140">
                    <template slot-scope="scope">
                        <el-button class="public_icon_xiugai public_icon_width" type="info" size="small"
                            @click="deleteFd(scope.row)" id="删除">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pulbic_pagesize">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
                    layout="total,sizes, prev, pager, next, jumper" :total="pagingPageMo">
                </el-pagination>
            </div>
        </div>
        <!--返点调控-->
        <div class="public-dialog">
            <el-dialog title="新增返点信息" :visible.sync="fandianShow" width="560px" custom-class="rebate-setting-dialog" :closeOnClickModal="false" append-to-body>
                <div class="systemCorporateAccount-dialog">
                    <div class="systemCorporateAccount-dialog-li">
                        <div class="SCADL-text">客户名称<span>*</span></div>
                        <div class="SCADL-input">
                            <el-select class="public_optionSty dropDown_Define" v-model="fdObj.khId" placeholder="请选择"
                                filterable @change="khChange" remote :remote-method="filterCustomer">
                                <el-option v-for="item in filteredCustomerOptions" :key="item.ORMTB410ID"
											:label="item.ORMTB410CA00" :value="item.ORMTB410ID">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="systemCorporateAccount-dialog-li">
                        <div class="SCADL-text">企业名称<span>*</span></div>
                        <div class="SCADL-input">
                            <el-select class="public_optionSty dropDown_Define" @change="fdPageMaterialList"
                                @clear="clearEnterprise"
                                v-model="fdObj.cjId" placeholder="请选择" filterable clearable remote :remote-method="filterDialogEnterprise">
                                <el-option v-for="item in filteredDialogEnterpriseOptions" :key="item.SETTB99ID" :label="item.SETTB99CA00"
                                    :value="item.SETTB99ID">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="systemCorporateAccount-dialog-li">
                        <div class="SCADL-text">物料名称</div>
                        <div class="SCADL-input">
                            <el-select class="public_optionSty dropDown_Define" @change="onSelecteLable"
                                @clear="clearFunWl" v-model="fdObj.wls" clearable multiple collapse-tags
                                :placeholder="fdObj.cjId ? '请选择' : '请先选择企业'" :disabled="!fdObj.cjId" filterable>
                                <el-option v-for="item in fdmaterList" :key="item.SETTB109ID" :label="item.SETTB109CA00"
                                    :value="item.SETTB109ID">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="systemCorporateAccount-dialog-li">
                        <div class="SCADL-text">返点比率<span>*</span></div>
                        <div class="SCADL-input">
                            <input type="text" v-model="fdObj.fdbl" placeholder="请输入" />
                        </div>
                    </div>
                    <div class="systemCorporateAccount-dialog-li">
                        <div class="SCADL-text">开始时间<span>*</span></div>
                        <div class="SCADL-input">
                            <el-date-picker v-model="fdObj.startTime" type="datetime" placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="systemCorporateAccount-dialog-li">
                        <div class="SCADL-text">结束时间<span>*</span></div>
                        <div class="SCADL-input">
                            <el-date-picker v-model="fdObj.endTime" type="datetime" placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="systemCorporateAccount-dialog-btn">
                        <el-button type="warning" @click="fandianShow = false">取消</el-button>
                        <el-button type="primary" @click="commitVerify">保存</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import customerSearchMixin from '@/mixins/customerSearchMixin'
import enterpriseSearchMixin from '@/mixins/enterpriseSearchMixin'
export default {
  mixins: [customerSearchMixin, enterpriseSearchMixin],
    data() {
        return {
            uobj: this.$store.state.uobj, //登陆缓存--用户信息
            tableData: [],
            ORMTB440CA00: '',
            ORMTB470CA12: '',
            ORMTB470CA40: '',
            ORMTB410CA04: '',
            materialOptions: [],
            materialTypeValue: '',
            carNum: '',
            materielMo: '',
            materielOptions: [
                {
                    SETTB109CA00: '全部',
                    SETTB109ID: '',
                },
            ],
            // 查询
            customerMo: '', //客户--查询
            SETTB122CA07: '', //数据状态
            enterpriseTwoOptionList: [
                {
                    SETTB109CA00: '全部',
                    SETTB109ID: '',
                },
            ], //二级企业下拉框--新增
            enterpriseTwo: '', //二级企业
            carNumber: '', //车牌号
            pageMo: 1, //默认列表页码
            limitMo: 10, //每页的条数
            pagingPageMo: 0, //分页--数据列表共有的条数
            currentPage: 1, //设置当前页默认为1
            // 历史缓存
            currentUrl: this.$route.path,
            historyInfo: '',
            fandianShow: false,
            fdObj: {
                cjName: '',
                cjId: '',
                fdbl: '',
                wlName: '',
                wlId: '',
                wls: [],
                wlobjs: [],
                khName: '',
                khId: '',
                startTime: '',
                endTime: '',
            },
            cjList: [],
            fdmaterList: [],
            fdmaterCache: {},
            enterpriseTwoOptionListAll:[],
            filteredDialogEnterpriseOptions: []
        }
    },
    created() {
        var list = ''
        list = this.$store.state.solelist
        // 赋值，缓存销毁
        this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
        sessionStorage.removeItem(this.currentUrl)
        if (this.historyInfo != null && this.historyInfo != '') {
            this.init()
        }
        // else {
        // 	this.getNowDay();
        // }
        var path = this.$route.path
        // console.log(path)
        if (path === '/rebateSetting') {
            path = '/Home' + path
        }
        this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表
    },
    mounted() {
        this.enterprise0ptions()
        this.enterprise2Options()
        this.enterprise2Options()
        this.queryClick()
    },
    methods: {
        clearEnterprise() {
            this.fdObj.cjName = ''
            this.fdObj.wls = []
            this.fdObj.wlobjs = []
            this.fdmaterList = []
        },
        onEnterpriseLoaded(data) {
            this.enterpriseTwoOptionListAll = data
            this.filteredDialogEnterpriseOptions = data.slice(0, 100)
        },
        filterDialogEnterprise(query) {
            if (!query) {
                this.filteredDialogEnterpriseOptions = this.enterpriseTwoOptionListAll.slice(0, 100)
                return
            }
            const q = query.toLowerCase()
            this.filteredDialogEnterpriseOptions = this.enterpriseTwoOptionListAll.filter(item =>
                (item.SETTB99CA00 || '').toLowerCase().includes(q) ||
                (item.SETTB99CA00PY || '').toLowerCase().includes(q)
            )
        },
        khChange(value) {
            const item = this.customerOptionsAll.find(item => item.ORMTB410ID === value);
            this.fdObj.khName = item.ORMTB410CA00;
        },
        deleteFd(item) {
            var postData = {
                SETTB420ID: item.SETTB420ID,
            }
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    let loading = this.$loading({
                        lock: true,
                        text: '请求中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)',
                    })
                    var url = 'set/settb420/delete'
                    this.axios
                        .post(url, postData)
                        .then(res => {
                            setTimeout(() => {
                                loading.close()
                            }, 300)
                            if (res.data.code == 200) {
                                this.queryClick();
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!',
                                })
                            } else {
                                this.$message({
                                    message: res.data.message,
                                    type: 'error',
                                })
                            }
                        })
                        .catch(() => {
                            loading.close()
                        })
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除',
                    })
                })
        },
        commitVerify() {
            if (this.fdObj.khId.trim().length == 0) 
            return this.$message.error('请选择客户')
            if (this.fdObj.cjName.trim().length == 0)
                return this.$message.error('请选择厂家')
            if (this.fdObj.fdbl.toString().trim().length == 0)
                return this.$message.error('请输入返点比率')
            if (this.fdObj.startTime.length === 0)
                return this.$message.error('请选择开始时间')
            if (this.fdObj.endTime.length === 0)
                return this.$message.error('请选择结束时间')
            if (!/^-?\d+(\.\d+)?$/.test(this.fdObj.fdbl)) {
                return this.$message.error('请输入有效的返点比率')
            }
            if (this.fdObj.startTime >= this.fdObj.endTime) {
                return this.$message.error('结束时间需大于开始时间')
            }
            if (this.fdObj.wlobjs.length == 0) {
                this.$confirm('不选择物料将对所有物料进行设置, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                    .then(() => {
                        this.commitFdModify()
                    })
                    .catch(() => { })
            } else {
                this.commitFdModify()
            }
        },
        dateFtt(fmt, date) {
      //author: meizz
      var o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      }
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
      for (var k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ('00' + o[k]).substr(('' + o[k]).length)
          )
      return fmt
    },
        commitFdModify() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                SETTB420CA00: this.fdObj.cjName,
                SETTB420CA01: this.fdObj.cjId,
                SETTB420CA02: this.fdObj.wlName,
                SETTB420CA03: this.fdObj.wlId,
                SETTB420CA04: this.fdObj.khName,
                SETTB420CA05: this.fdObj.khId,
                SETTB420CA07: this.fdObj.fdbl,
                SETTB420CA09: this.dateFtt(
                    'yyyy-MM-dd hh:mm:ss',
                    new Date(this.fdObj.startTime)
                ),
                SETTB420CA10: this.dateFtt(
                    'yyyy-MM-dd hh:mm:ss',
                    new Date(this.fdObj.endTime)
                ),
                WLOBJS: this.fdObj.wlobjs,
            }
            var url = 'set/settb420/save'
            this.axios
                .post(url, postData)
                .then(res => {
                    if (res.data.code == 200) {
                        this.fandianShow = false
                        this.queryClick()
                        this.$message({
                            message: '保存成功',
                            type: 'success',
                        })
                    } else {
                        this.$message({
                            message: '保存失败',
                            type: 'error',
                        })
                        this.fandianShow = false
                    }
                    setTimeout(() => {
                        loading.close()
                    }, 300)
                })
                .catch(() => {
                    loading.close()
                })
        },
        clearFunWl() {
            this.fdObj.wlId = ''
            this.fdObj.wlName = ''
        },
        changjiaList(data) {
            var url = '/set/settb100/selectSettb100ByCa02'
            var loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
                type: 1,
            }
            this.axios
                .post(url, postData)
                .then(res => {
                    // console.log(res)
                    if (res.data.code == 200) {
                        console.log(res)
                        this.cjList = res.data.data
                        //this.selectData()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                    setTimeout(() => {
                        loading.close()
                    }, 300)
                })
                .catch(() => {
                    loading.close()
                })
        },
        onSelecteLable() {
            const idSet = new Set(this.fdObj.wls)
            this.fdObj.wlobjs = this.fdmaterList.filter(item =>
                idSet.has(item.SETTB109ID)
            )
        },
        onSelecteLableCj() {
            let obj = {}
            obj = this.enterpriseTwoOptionListAll.find(item => {
                //这里的userList就是上面遍历的数据源
                return item.SETTB99ID === this.fdObj.cjId //筛选出匹配数据
            })
            this.fdObj.cjName = obj.SETTB99CA00
        },
        /*根据厂家查物料*/
        fdPageMaterialList() {
            this.fdObj.wlId = ''
            this.fdObj.wls = []
            this.fdObj.wlobjs = []
            if (!this.fdObj.cjId) return
            this.onSelecteLableCj()
            const cjId = this.fdObj.cjId
            if (this.fdmaterCache[cjId]) {
                this.fdmaterList = this.fdmaterCache[cjId]
                return
            }
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            this.axios.post('set/settb109/selectPageList', {
                SETTB99ID: cjId,
                SETTB109CD01: '',
                limit: '1000',
                page: '1',
            }).then(res => {
                setTimeout(() => { loading.close() }, 300)
                if (res.data.code == 200) {
                    this.fdmaterCache[cjId] = res.data.data
                    this.fdmaterList = res.data.data
                    this.fdpagingPageMaterial = res.data.count
                } else {
                    this.$message({ message: res.data.message, type: 'error' })
                }
            }).catch(() => { loading.close() })
        },
        selectwlhxPageListFun() {
            //根据厂家获取物料含税价和不含税价信息
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                SETTB99ID: this.fdObj.cjId,
                ORMTB410ID: this.objuserMsg.ORMTB410ID,
                limit: this.hsjListlimitMaterial,
                page: this.hsjListpageMaterial,
            }
            this.materList = []
            var fdmoList
            var url = 'set/settb109/selectwlhxPageList'
            this.axios
                .post(url, postData)
                .then(res => {
                    console.log(res)
                    setTimeout(() => {
                        loading.close()
                    }, 300)
                    if (res.data.code == 200) {
                        fdmoList = res.data.data.list
                        this.fdmaterList = fdmoList
                        this.hsjListpagingPageMaterial = res.data.count

                        if (res.data.data.taxSwitch == 0) {
                            this.hanshuijiaKG = false
                            this.hsjstus = 0
                        } else {
                            this.hanshuijiaKG = true
                            this.hsjstus = 1
                        }
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        // 新增
        addClick() {
            this.fandianShow = true;
            this.fdObj = {
                cjName: '',
                cjId: '',
                fdbl: '',
                wlName: '',
                wlId: '',
                wls: [],
                wlobjs: [],
                khName: '',
                khId: '',
                startTime: '',
                endTime: '',
            }
        },
        // 获取派单物料列表
        getSelectMaterial(row) {
            var postData = {
                SETTB99ID: row.ORMTB470CA04,
            }
            this.materialList = []
            postData = qs.stringify(postData)
            var url = '/set/settb109/select_material'
            this.axios
                .post(url, postData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.materialList = res.data.data
                        // this.materialValue = this.detailsList.ORMTB440CC01
                        if (this.detailsList.ORMTB470CA18) {
                            this.materialValue = this.detailsList.ORMTB470CA18
                        } else {
                            this.materialValue = this.detailsList.ORMTB470CA06
                            // console.log(this.detailsList)
                            this.queryMaterialPrice(this.materialValue)
                        }
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        //初始化数据
        init() {
            this.currentPage = this.historyInfo.currentPage
            this.pageMo = this.historyInfo.pageMo
            this.limitMo = this.historyInfo.limitMo
        },
        materielMoPost() {
            var i = (this.enterpriseTwoOptionList || []).findIndex(
                profile => profile.SETTB99ID === this.enterpriseTwo
            )
            var url = '/set/settb109/selectPageList'
            var SETTB100ID = this.enterpriseTwoOptionList[i].SETTB100ID
            var data = {
                SETTB109CA03: '',
                SETTB109CA00: '',
                SETTB109CD01: SETTB100ID,
                SETTB99ID: this.enterpriseTwo,
                page: 1,
                limit: 1000,
            }
            var List = [
                {
                    SETTB109CA00: '全部',
                    SETTB109ID: '',
                },
            ]
            this.axios.post(url, data).then(res => {
                if (res.data.code == 200) {
                    this.materielOptions = [...List, ...res.data.data]
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        erpChange() {
            if (this.enterpriseTwo != '') {
                this.materielMoPost()
            } else {
                this.materielOptions = [
                    {
                        SETTB109CA00: '全部',
                        SETTB109ID: '',
                    },
                ]
            }
        },

        // 查询
        queryClick() {
            this.pageList()
        },
        // 列表
        pageList() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                SETTB420CA05: this.customerMo,
                SETTB420CA01:this.enterpriseTwo,
                SETTB420CA03: this.materielMo,
                page: this.pageMo,
                limit: this.limitMo,
            }
            var url = 'set/settb420/list'
            this.axios
                .post(url, postData)
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 300)
                    if (res.data.code == 200) {
                        this.tableData = res.data.data
                        this.pagingPageMo = res.data.count
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        handleSizeChange(val) {
            this.pageMo = 1
            this.limitMo = val
            this.pageList()
        },
        // 点击页码
        handleCurrentChange(val) {
            this.pageMo = val
            this.pageList()
        },
    },
}
</script>

<style scoped>

.DWD-li {
    display: flex;
    height: 35px;
    line-height: 35px;
    box-sizing: border-box;
    /* border: 1px solid #999; */
    font-size: 16px;
    color: #333;
}

.DWD-li>div {
    padding: 0 5px;
    height: 34px;
    overflow: hidden;
    box-sizing: border-box;
}

.DWD-li-title {
    width: 150px;
    text-align: center;
    border-right: 1px solid #999;
    background-color: rgba(0, 163, 255, 0.1);
}

.DWD-li-text {
    flex: 1;
}

.DWD-li-text input {
    width: 100%;
    height: 35px;
    line-height: 35px;
    font-size: 0.833vw;
    border: none;
    outline: none;
}

.DWD-li+.DWD-li {
    border-top: none;
}

.DWD-table {
    display: flex;
}

.DWD-table-left-flex {
    flex: 1;
}

.DWD-table>div>div {
    padding: 0 5px;
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    text-align: center;
    border-right: 1px solid #999;
    /* border-bottom: 1px solid #999; */
    box-sizing: border-box;
}

.DWD-table>div>div:first-child {
    background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table-left-title>div {
    width: 101px;
    text-align: center;
    background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table .DWD-table-left-title>div {
    padding: 0 5px;
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    box-sizing: border-box;
    border-left: 1px solid #999;
    /* border-bottom: 1px solid #999; */
}

.DetailsWater-img {
    margin-top: 30px;
}

.DetailsWater-img-text {
    display: inline-block;
    width: 101px;
    text-align: center;
    vertical-align: top;
}

.car-number-add {
    /* text-transform: uppercase; */
}

.billOperationRecord-table {
    padding: 30px 20px 0;
}

.public_singleMenu .pulic_carNumber {
    margin-top: 6px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 14px;
    display: inline-block;
}

.pulic_operatArea_now:hover,
.public_operatArea_yesterday:hover {
    background-color: #ccc;
}

/* 新增--列表宽度 */
.billOperationRecord .systemCodePC-add-code-table-li-ipt {
    flex: 1.5;
}

.fontBlue {
    color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
    margin-top: 6px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 14px;
    display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
    height: 45px;
    align-items: center;
}

.rebate-setting-page {
    min-height: 100%;
    padding: 16px;
    background: #f4f8fc;
    box-sizing: border-box;
}

.rebate-setting-page .pulbic_oparetionBlock,
.rebate-setting-table-card {
    border: 1px solid #e3edf7;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 8px 24px rgba(31, 93, 154, .08);
}

.rebate-setting-filter-card {
    padding: 18px 20px 16px;
}

.rebate-setting-section-head,
.rebate-setting-table-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
}

.rebate-setting-section-title {
    position: relative;
    padding-left: 12px;
    color: #183b5b;
    font-size: 18px;
    font-weight: 800;
    line-height: 1.2;
}

.rebate-setting-section-title::before {
    position: absolute;
    top: 2px;
    left: 0;
    width: 4px;
    height: 18px;
    border-radius: 4px;
    background: #2689e8;
    content: '';
}

.rebate-setting-section-subtitle {
    margin-top: 6px;
    padding-left: 12px;
    color: #7b8fa6;
    font-size: 13px;
}

.rebate-setting-filter-row {
    display: flex;
    align-items: flex-end;
    gap: 16px;
}

.rebate-setting-criteria {
    display: flex;
    flex: 1;
    align-items: center;
    gap: 16px;
    min-width: 0;
}

.rebate-setting-page .public_oparetionBlock_Menu {
    display: flex;
    align-items: center;
    flex: 0 1 auto;
    min-width: 0;
    height: auto;
    margin: 0;
}

.rebate-setting-page .public_lbSty {
    min-width: 54px;
    color: #51687f;
    font-size: 14px;
    font-weight: 700;
    text-align: right;
}

.rebate-setting-page .public_optionSty {
    width: auto;
    min-width: 180px;
    max-width: 280px;
}

.rebate-setting-page .public_oparetionBlock_Menu:nth-child(1) .public_optionSty,
.rebate-setting-page .public_oparetionBlock_Menu:nth-child(2) .public_optionSty {
    min-width: 220px;
    max-width: 320px;
}

.rebate-setting-page /deep/ .el-input__inner {
    height: 36px;
    line-height: 36px;
    border-color: #d9e7f3;
    border-radius: 9px;
}

.rebate-setting-page /deep/ .el-input__inner:focus {
    border-color: #2689e8;
}

.rebate-setting-actions-row {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    height: 36px;
    margin: 0 !important;
}

.rebate-setting-actions {
    display: flex;
    align-items: center;
    width: auto;
    gap: 10px;
    justify-content: flex-end;
    margin: 0 !important;
}

.rebate-setting-actions .public_saleWater_chaxun {
    min-width: 84px;
    height: 36px;
    padding: 0 16px;
    border: none;
    border-radius: 18px;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    line-height: 36px;
    background: linear-gradient(135deg, #3aa0ff, #1976d2);
    box-shadow: 0 6px 14px rgba(38, 137, 232, .24);
}

.rebate-setting-actions .public_saleWater_xinzeng {
    background: linear-gradient(135deg, #24c875, #0f9f5c);
    box-shadow: 0 6px 14px rgba(22, 160, 93, .24);
}

.rebate-setting-table-head {
    margin-top: 8px;
}

.rebate-setting-table-card {
    margin-top: 16px;
    padding: 18px 20px 12px;
}

.rebate-setting-table-card /deep/ .el-table {
    overflow: hidden;
    border: 1px solid #e3edf7;
    border-radius: 12px;
}

.rebate-setting-table-card /deep/ .el-table th {
    background: #f0f7ff !important;
    color: #24435f !important;
    font-size: 14px;
    font-weight: 800 !important;
}

.rebate-setting-table-card /deep/ .el-table td {
    color: #34495e;
    font-size: 13px;
}

.rebate-setting-table-card /deep/ .el-table__row:hover > td {
    background: #f7fbff !important;
}

.rebate-setting-table-card /deep/ .public_icon_width {
    min-width: 70px;
    border: none;
    border-radius: 15px;
    background: #fff0f0;
    color: #e34d4d;
    font-weight: 700;
}

.rebate-setting-table-card /deep/ .public_icon_width:hover {
    background: #e34d4d;
    color: #fff;
}

.rebate-setting-table-card .pulbic_pagesize {
    display: flex;
    justify-content: flex-end;
    padding-top: 14px;
}

.rebate-setting-dialog .el-dialog__header {
    padding: 18px 22px 14px;
    border-bottom: 1px solid #edf3f8;
}

.rebate-setting-dialog .el-dialog__title {
    color: #183b5b;
    font-size: 18px;
    font-weight: 800;
}

.rebate-setting-dialog .el-dialog__body {
    padding: 20px 24px 22px;
}

.rebate-setting-dialog .systemCorporateAccount-dialog-li {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
}

.rebate-setting-dialog .SCADL-text {
    width: 86px;
    flex-shrink: 0;
    color: #51687f;
    font-size: 14px;
    font-weight: 700;
    text-align: right;
}

.rebate-setting-dialog .SCADL-text span {
    margin-left: 2px;
    color: #e34d4d;
}

.rebate-setting-dialog .SCADL-input {
    flex: 1;
    min-width: 0;
}

.rebate-setting-dialog .SCADL-input input {
    width: 100%;
    height: 36px;
    padding: 0 12px;
    border: 1px solid #d9e7f3;
    border-radius: 9px;
    color: #22384d;
    box-sizing: border-box;
    outline: none;
}

.rebate-setting-dialog .SCADL-input .el-select,
.rebate-setting-dialog .SCADL-input .el-date-editor {
    width: 100%;
}

.rebate-setting-dialog .systemCorporateAccount-dialog-btn {
    display: flex;
    justify-content: flex-end;
    gap: 60px;
    margin-top: 20px;
}

.rebate-setting-dialog .systemCorporateAccount-dialog-btn .el-button {
    min-width: 86px;
    border-radius: 17px;
    font-weight: 700;
}

@media screen and (max-width: 1280px) {
    .rebate-setting-filter-row {
        align-items: stretch;
        flex-direction: column;
    }

    .rebate-setting-actions-row,
    .rebate-setting-actions {
        width: 100%;
    }
}

.billOperationRecord {
    background-color: #f4f8fc;
}

.billOperationRecord th,
.billOperationRecord td {
    text-align: center !important;
}

/* 统计 START*/
.imgStatistics {
    width: 40px;
    height: 40px;
}

.payType {
    /* font-size: 15px; */
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(102, 102, 102, 1);
    line-height: 26px;
}

.singular {
    /* font-size: 14px; */
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 30px;
    vertical-align: middle;
    padding-left: 10px;
}

.Amount {
    /* font-size: 14px; */
    font-family: Microsoft YaHei;
    /* font-weight:bold; */
    line-height: 30px;
    vertical-align: middle;
    padding-left: 10px;
}

.pulic_statistics_titlt {
    line-height: 40px;
    /* font-size: 14px; */
}

.billDetails-statistics {
    justify-content: space-around;
}

.public_statisticsInfo {
    margin-top: 5px;
    margin-bottom: 10px;
}

.input_ {
    display: flex;
    height: 2.34vw;
    line-height: 2vw;
}

::v-deep .el-input__inner {
    /* width: 7.083vw; */
    height: 1.7vw;
}

:v-deep .el-input {
    width: unset;
}

/* 统计 END*/
.public_operatBtn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 0 !important;
}

.public_operatArea {
    margin-bottom: 0;
}

.systemCorporateAccount-wuliao-input>input {
    height: 40px;
    box-sizing: border-box;
    /* border: 1px solid #dcdfe6; */
    border-radius: 5px;
    padding-left: 5px;
}

.num {
    color: #333;
    font-size: 18px;
}

.cJ-btn {
    margin-top: 20px;
}

.shouQuanChangJia-dialog .el-checkbox {
    margin-bottom: 15px;
}

/deep/ .num .el-input .el-input__inner {
    font-size: 18px !important;
}

::v-deep .addPointer {
    cursor: pointer;
}

::v-deep .success-row {
    background-color: #81d3f8 !important;
}
</style>

<style>
.rebate-setting-dialog .el-dialog__header {
    padding: 18px 22px 14px;
    border-bottom: 1px solid #edf3f8;
}

.rebate-setting-dialog .el-dialog__title {
    color: #183b5b;
    font-size: 18px;
    font-weight: 800;
}

.rebate-setting-dialog .el-dialog__body {
    padding: 20px 24px 22px;
}

.rebate-setting-dialog .SCADL-input .el-select,
.rebate-setting-dialog .SCADL-input .el-date-editor {
    width: 100%;
}

.rebate-setting-dialog .systemCorporateAccount-dialog-btn .el-button {
    min-width: 86px;
    border-radius: 17px;
    font-weight: 700;
}
</style>
